import { Avatar, Stack, Text } from '@7shifts/sous-chef-base';
import type { ClockUser } from '@src/api/punchTypes';
import { useTranslation } from '@src/i18n';

export function GreetingView({ user }: { user: ClockUser }) {
    const { t } = useTranslation();
    return (
        <div data-testid="greeting-view">
            <Stack space={20} alignItems="center">
                <Stack space={4} alignItems="center">
                    <Text as="h1" alignment="center">
                        {t('userStatus.greeting', {
                            firstName: user.firstName
                        })}
                    </Text>
                    <Text
                        as="body"
                        alignment="center"
                        color="var(--color-surface-on-color-subtle)"
                    >
                        {t('userStatus.haveAGreatShift')}
                    </Text>
                </Stack>
                <Avatar
                    size="extra-large"
                    url={user.profilePictureUrl}
                    alt={`${user.firstName} ${user.lastName}`.trim()}
                />
            </Stack>
        </div>
    );
}
